import React from "react";
import NavigationItem from "./NavigationItem/NavigationItem";
import "./NavigationBlock.css";
import { FaWhatsapp } from "react-icons/fa";

const items = [
  { name: "Главная", to: "/" },
  { name: "О компании", to: "/about" },
  { name: "Услуги и цены", to: "/services_prices" },
  { name: "Проекты", to: "/projects" },
  { name: "Контакты", to: "/contacts" },
];

const NavigationBlock = ({ active, actionMenu, color }) => (
  <nav className={`nav ${active ? "nav_active" : ""}`}>
    <ul className="nav__list">
      {items.map((item) => (
        <li key={item.name}>
          <NavigationItem
            to={item.to}
            name={item.name}
            actionMenu={actionMenu}
            color={color}
          />
        </li>
      ))}
      <a
        href="https://wa.me/996709683738"
        target="_blank"
        rel="noreferrer"
      >
        <button className="nav__button">
          Написать на <FaWhatsapp className="icon" size={22} />
        </button>
      </a>
    </ul>
  </nav>
);

export default NavigationBlock;
